.rows {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.row {
  display: grid;
  grid-template-columns: 5.75rem minmax(0, 1fr);
  min-width: 0;

  &[data-stacked] {
    width: 100%;
    grid-template-columns: minmax(0, 1fr);
  }
  align-items: center;
  gap: 0.5rem;
}

.rowHeader {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.rowLabel {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--color-muted);
  transition: color 150ms ease;
}

.rowIcon {
  display: grid;
  place-items: center;
  color: var(--color-muted-foreground);
  transition: color 150ms ease;

  svg {
    width: 1.125rem;
    height: 1.125rem;
  }
}

// A row with a value pressed: its options are in the transform.
.row[data-on] {
  .rowLabel {
    color: var(--color-foreground);
  }

  .rowIcon {
    color: var(--color-primary);
  }
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.chip {
  min-width: 2.5rem;
  padding: 0.25rem 0.625rem;
  border: 1px solid var(--color-border);
  border-radius: 999px;
  background: transparent;
  color: var(--color-foreground);
  font: inherit;
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: start;
  font-size: 0.8125rem;
  font-weight: 500;
  cursor: pointer;
  transition:
    background-color 150ms ease,
    border-color 150ms ease;

  &:hover {
    background: var(--color-surface-raised);
  }

  &[aria-pressed="true"] {
    border-color: var(--color-primary);
    background: var(--color-primary-soft);
  }

  &:focus-visible {
    outline: 3px solid var(--color-focus-ring);
    outline-offset: 2px;
  }

  // Dashed and muted, never faded.
  &:disabled {
    border-style: dashed;
    color: var(--color-muted-foreground);
    cursor: not-allowed;

    &:hover {
      background: transparent;
    }
  }
}

.rowActions {
  margin-inline-start: auto;
  flex-shrink: 0;
}
